import React from 'react';
import { GlobalStyles, color, font, textSize } from '@kis-technologies/kis-ui';
import { lighten } from 'polished';

const styles = {
  '*': {
    boxSizing: 'border-box'
  },
  html: {
    fontFamily: 'sans-serif',
    textSizeAdjust: '100%',
    height: '100%'
  },
  body: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    lineHeight: 1.5,
    fontWeight: 500,
    fontFamily: font.BASE,
    fontSize: textSize.kiosk.BASE
  },
  'div[id="root"]': {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto'
  },
  p: { margin: '5px 0 0 0' },
  ul: { margin: '5px 0 0 0' },
  ol: { margin: '5px 0 0 0' },
  dl: { margin: '5px 0 0 0' },
  h1: { fontSize: textSize.kiosk.H1, fontWeight: 600 },
  h2: { fontSize: textSize.kiosk.H2, fontWeight: 600 },
  h3: { fontSize: textSize.kiosk.H3, fontWeight: 600 },
  h4: { fontSize: textSize.kiosk.H4, fontWeight: 600 },
  h5: { fontSize: textSize.kiosk.H5, fontWeight: 600 },
  h6: { fontSize: textSize.kiosk.H6, fontWeight: 600 },
  a: {
    color: color.BLACK,
    textDecoration: 'none',
    '&:hover': {
      color: lighten(0.05, color.BLACK)
    }
  },
  code: {
    fontFamily: font.BASE
  },
  small: {
    fontSize: textSize.kiosk.SMALL
  },
  hr: {
    border: 'none',
    height: '1px',
    background: color.PRIMARY
  }
};

const KioskStyleBase = () => <GlobalStyles styles={styles} />;

export default KioskStyleBase;
